"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GeometryLayout = _interopRequireDefault(require("./GeometryLayout.js"));

var _GeometryType = _interopRequireDefault(require("./GeometryType.js"));

var _SimpleGeometry = _interopRequireDefault(require("./SimpleGeometry.js"));

var _closest = require("./flat/closest.js");

var _extent = require("../extent.js");

var _deflate = require("./flat/deflate.js");

var _simplify = require("./flat/simplify.js");

var _inflate = require("./flat/inflate.js");

var _area = require("./flat/area.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/LinearRing
 */


/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */
var LinearRing =
/** @class */
function (_super) {
  __extends(LinearRing, _super);
  /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   */


  function LinearRing(coordinates, opt_layout) {
    var _this = _super.call(this) || this;
    /**
     * @private
     * @type {number}
     */


    _this.maxDelta_ = -1;
    /**
     * @private
     * @type {number}
     */

    _this.maxDeltaRevision_ = -1;

    if (opt_layout !== undefined && !Array.isArray(coordinates[0])) {
      _this.setFlatCoordinates(opt_layout,
      /** @type {Array<number>} */
      coordinates);
    } else {
      _this.setCoordinates(
      /** @type {Array<import("../coordinate.js").Coordinate>} */
      coordinates, opt_layout);
    }

    return _this;
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   */


  LinearRing.prototype.clone = function () {
    return new LinearRing(this.flatCoordinates.slice(), this.layout);
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */


  LinearRing.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
    if (minSquaredDistance < (0, _extent.closestSquaredDistanceXY)(this.getExtent(), x, y)) {
      return minSquaredDistance;
    }

    if (this.maxDeltaRevision_ != this.getRevision()) {
      this.maxDelta_ = Math.sqrt((0, _closest.maxSquaredDelta)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
      this.maxDeltaRevision_ = this.getRevision();
    }

    return (0, _closest.assignClosestPoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
  };
  /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */


  LinearRing.prototype.getArea = function () {
    return (0, _area.linearRing)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
  };
  /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */


  LinearRing.prototype.getCoordinates = function () {
    return (0, _inflate.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
  };
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   */


  LinearRing.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
    var simplifiedFlatCoordinates = [];
    simplifiedFlatCoordinates.length = (0, _simplify.douglasPeucker)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return new LinearRing(simplifiedFlatCoordinates, _GeometryLayout["default"].XY);
  };
  /**
   * Get the type of this geometry.
   * @return {import("./GeometryType.js").default} Geometry type.
   * @api
   */


  LinearRing.prototype.getType = function () {
    return _GeometryType["default"].LINEAR_RING;
  };
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */


  LinearRing.prototype.intersectsExtent = function (extent) {
    return false;
  };
  /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @api
   */


  LinearRing.prototype.setCoordinates = function (coordinates, opt_layout) {
    this.setLayout(opt_layout, coordinates, 1);

    if (!this.flatCoordinates) {
      this.flatCoordinates = [];
    }

    this.flatCoordinates.length = (0, _deflate.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
    this.changed();
  };

  return LinearRing;
}(_SimpleGeometry["default"]);

var _default = LinearRing;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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